import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'reducer/store';

const defautRetaierId = createSlice({
  name: 'defautRetaierId',
  initialState: '',
  reducers: {
    setDefautRetaierIdReducer: (state, action: PayloadAction<string>) =>
      action.payload,
  },
});
// 取值 get
export const getDefautRetaierIdReducer = (state: RootState) =>
  state.defautRetaierIdReducer;
// set
export const defautRetaierIdAction = defautRetaierId.actions;
const defautRetaierIdReducer = defautRetaierId.reducer;
export default defautRetaierIdReducer;
